import { styled } from '@/stitches.config';

import { ReactComponent as Briefcase } from '@assets/icons/briefcase.svg';
import { ReactComponent as Home } from '@assets/icons/home.svg';
import { ReactComponent as CollectionSaliva } from '@assets/icons/collection-saliva.svg';

import { Box } from '@base-app';

export const BriefcaseIcon = styled(Briefcase, {});

export const HomeIcon = styled(Home, {});

export const StyledCardContainer = styled(Box, {
  display: 'flex',
});

export const CollectionSalivaIcon = styled(CollectionSaliva, {});
